import { Link } from "react-router-dom";

export default function AdminNavbar({ onLogout }) {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark mb-4">
      <div className="container">
        <Link className="navbar-brand" to="/admin/dashboard">
          Admin Panel
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#adminNavbar"
          aria-controls="adminNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="adminNavbar">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/admin/dashboard">
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/banners">
                Banners
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/banners/add">
                Add Banner
              </Link>
            </li>
          </ul>
          <button className="btn btn-outline-light" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}
